export enum BusinessType {
  Other = "Other",
  Limited = "Limited",
  PartnerShip = "PartnerShip",
  SoleTrader = "SoleTrader",
  TrustSociety = "TrustSociety",
}
